import script from "./CarouselPageNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarouselPageNav.vue?vue&type=script&setup=true&lang=ts"

import "./CarouselPageNav.vue?vue&type=style&index=0&id=22687440&lang=scss"

const __exports__ = script;

export default __exports__